import $ from 'gridstrap/lib/gs-zepto';

export class GSSlidingFooter {

	//
	// Properties
	//

	root;

	get step() { return this.root.data('gsSlidingFooterStep'); }
	set step(value) { this.root.data('gsSlidingFooterStep', value); }

	//
	// Methods
	//

	next(evt) {
		const clicked = $(evt.currentTarget);
		let delay = clicked.is('[role~="delayed"]') ? 1000 : 0;
		setTimeout(() => this.step++, delay);
	}

	//
	// Initializers & Event Handlers
	//

	constructor(root) {
		this.root = $(root);
	}

	gsOnInit() {
		this.root.on('click', '[role~="next"]', evt => this.next(evt));
	}

}
